import script from "./PaymentInstructionsBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentInstructionsBlock.vue?vue&type=script&setup=true&lang=js"

import "./PaymentInstructionsBlock.vue?vue&type=style&index=0&id=406b43d7&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-406b43d7"]])

export default __exports__